'use client';
import { memo } from 'react';

import { breakpoints } from 'app/themeConfig';
import SmallProjectsCasesCard from 'entities/SmallProjectsCasesCard';
import BigProjectsCasesCard from 'entities/BigProjectsCasesCard';
import { useMobileDevice } from 'shared/hooks';

const ProjectsCasesCard = ({
  isBigCard = false,
  companyLogo,
  companyLogoProps,
  domain,
  illustration,
  cardScreen,
  title,
  link,
  description = null,
}) => {
  const { isMobileDevice: isOnlyMobileDevice } = useMobileDevice(breakpoints.tablet);

  const cardData = {
    companyLogo,
    companyLogoProps,
    domain,
    illustration,
    cardScreen,
    title,
    link,
    description,
  };

  if (isBigCard) {
    if (isOnlyMobileDevice) {
      // @ts-ignore
      return (
        <SmallProjectsCasesCard
          {...cardData}
          isBigCard={isBigCard}
          minH="473px"
          bgColor="#F5F7FA"
        />
      );
    } else {
      // @ts-ignore
      return <BigProjectsCasesCard {...cardData} />;
    }
  } else {
    // @ts-ignore
    return <SmallProjectsCasesCard {...cardData} />;
  }
};

export default memo(ProjectsCasesCard);
